import { Box, VStack, Divider, useColorModeValue, ScrollView } from 'native-base';
import React from 'react';
import { Linking, Platform } from 'react-native';
import { containerStyle } from 'src/styles/containerStyle';
import { Text, Pressable, HStack } from 'native-base';
import MaterialIconByName from 'src/components/MaterialIconByName';
import DeviceInfo from 'react-native-device-info';

export default function HelpPage() {

    const openEmail = (email: string) => {
        Linking.openURL(`mailto:${email}`);
    };

    const openPhone = (phone: string) => {
        Linking.openURL(`tel:${phone}`);
    };

    const cardBg = useColorModeValue('white', 'gray.800');
    const borderColor = useColorModeValue('gray.200', 'gray.700');
    const iconColor = useColorModeValue('blue.600', 'blue.400');
    const linkColor = useColorModeValue('#3B82F6', '#60A5FA');
    const secondaryTextColor = useColorModeValue('gray.600', 'gray.400');

    const ContactCard = ({ icon, title, description, contactInfo, onPress }: {
        icon: string;
        title: string;
        description: string;
        contactInfo: string;
        onPress: () => void;
    }) => (
        <Pressable onPress={onPress}>
            {({ isPressed, isHovered }) => (
                <Box
                    bg={cardBg}
                    borderWidth={1}
                    borderColor={borderColor}
                    borderRadius="lg"
                    p={4}
                    shadow={isPressed ? 1 : 2}
                    opacity={isPressed ? 0.8 : 1}
                    style={{
                        transform: [{ scale: isPressed ? 0.98 : 1 }]
                    }}>
                    <HStack space={4} alignItems="center">
                        <Box
                            bg={isPressed ? 'blue.100' : 'blue.50'}
                            _dark={{ bg: isPressed ? 'blue.900' : 'blue.900:alpha.30' }}
                            p={3}
                            borderRadius="full">
                            <MaterialIconByName name={icon} size="md" color={iconColor} />
                        </Box>
                        <VStack flex={1} space={1}>
                            <Text fontSize="xs" color={secondaryTextColor} fontWeight="500">
                                {title}
                            </Text>
                            <Text
                                fontSize="md"
                                fontWeight="600"
                                color={linkColor}>
                                {contactInfo}
                            </Text>
                            <Text fontSize="xs" color={secondaryTextColor}>
                                {description}
                            </Text>
                        </VStack>
                        <MaterialIconByName name="chevron-right" size="sm" color={secondaryTextColor} />
                    </HStack>
                </Box>
            )}
        </Pressable>
    );

    return (
        <Box variant={"main"} style={containerStyle.mainContainer}>
            <ScrollView>
                <VStack space={6} p={4}>
                <VStack space={2}>
                    <Text fontSize="sm" color={secondaryTextColor}>
                        We're here to help! Reach out to us through any of the channels below.
                    </Text>
                </VStack>

                <Divider />

                <VStack space={3}>
                    <Text fontSize="md" fontWeight="600" mb={1}>
                        Contact Us
                    </Text>

                    <ContactCard
                        icon="email-outline"
                        title="Technical Support"
                        description="For technical issues and assistance"
                        contactInfo="support@inweon.com"
                        onPress={() => openEmail('support@inweon.com')}
                    />

                    <ContactCard
                        icon="email-outline"
                        title="Sales & Subscriptions"
                        description="For subscription and billing inquiries"
                        contactInfo="grainiqinfo@gmail.com"
                        onPress={() => openEmail('grainiqinfo@gmail.com')}
                    />

                    <ContactCard
                        icon="phone-outline"
                        title="Phone Support (India)"
                        description="Call us for immediate assistance"
                        contactInfo="+91 98712-29228"
                        onPress={() => openPhone('9871229228')}
                    />

                    <ContactCard
                        icon="phone-outline"
                        title="Phone Support (International)"
                        description="Call us for immediate assistance"
                        contactInfo="(732) 640-8100"
                        onPress={() => openPhone('7326408100')}
                    />
                </VStack>

                <Box
                    bg="blue.50"
                    _dark={{ bg: 'blue.900:alpha.20' }}
                    p={4}
                    borderRadius="lg"
                    borderLeftWidth={4}
                    borderLeftColor="blue.500">
                    <HStack space={3} alignItems="flex-start">
                        <MaterialIconByName name="information-outline" size="sm" color={iconColor} />
                        <VStack flex={1} space={1}>
                            <Text fontSize="sm" fontWeight="600">
                                Business Hours
                            </Text>
                            <Text fontSize="xs" color={secondaryTextColor}>
                                Monday - Friday: 9:00 AM - 6:00 PM EST
                            </Text>
                            <Text fontSize="xs" color={secondaryTextColor}>
                                We typically respond within 24 hours
                            </Text>
                        </VStack>
                    </HStack>
                </Box>

                {(Platform.OS === 'android' || Platform.OS === 'ios') && (
                    <Box mt={4}>
                        <Text fontSize="xs" color={secondaryTextColor} textAlign="center">
                            Version {DeviceInfo.getVersion()} ({DeviceInfo.getBuildNumber()})
                        </Text>
                    </Box>
                )}
                </VStack>
            </ScrollView>
        </Box>
    );
}